import { Payment } from './CheckoutHeading.style';

type HeadingProps = {
  title: string;
};

const HeadingBase = ({ title }: HeadingProps) => (
  <Payment.Heading as="h1" fontSize="subtitle">
    {title}
  </Payment.Heading>
);

export default HeadingBase;
